<template>
  <div>
    <div id="view-sub-nav">
      <v-btn
        variant="outlined"
        color="primary"
        @click="
          () => {
            dialogMode = 'Create'
            selectedHandle = newHandleForm
            handleDialog = true
          }
        "
        >Create New Handle</v-btn
      >
      <v-spacer />
      <v-text-field
        v-model="tableSearch"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        density="compact"
        :clearable="true"
      ></v-text-field>
    </div>
    <v-data-table
      v-if="handles"
      :items="handles"
      :loading="loading"
      :headers="headers"
      :sort-by="[{ key: 'text', order: 'asc' }]"
      :items-per-page="25"
      :search="tableSearch"
    >
      <template v-slot:item.costUK="{ item }">
        <v-text-field
          class="ma-0 pa-0"
          :style="{ fontSize: '13px' }"
          v-model.number="item.costUK"
          @change="changed(item, 'costUK')"
          hide-details
          prefix="£"
        ></v-text-field>
      </template>
      <template v-slot:item.costUS="{ item }">
        <v-text-field
          class="ma-0 pa-0"
          :style="{ fontSize: '13px' }"
          v-model.number="item.costUS"
          @change="changed(item, 'costUS')"
          hide-details
          prefix="$"
        ></v-text-field>
      </template>
      <template v-slot:item.cutMu="{ item }">
        <v-text-field
          class="ma-0 pa-0"
          :style="{ fontSize: '13px' }"
          v-model.number="item.cutMu"
          @change="changed(item, 'cutMu')"
          hide-details
        ></v-text-field>
      </template>
      <template v-slot:item.finishMu="{ item }">
        <v-text-field
          class="ma-0 pa-0"
          :style="{ fontSize: '13px' }"
          v-model.number="item.finishMu"
          @change="changed(item, 'finishMu')"
          hide-details
        ></v-text-field>
      </template>
      <template v-slot:item.orientations="{ item }">
        <v-chip
          class="table-chips ma-1"
          v-for="(orientation, key) in item.orientations"
          :key="key"
          multiple
          small-chips
          density="compact"
          hide-details
          >{{ productData.getOrientation(orientation) }}</v-chip
        >
      </template>
      <template v-slot:item.actions="{ item }">
        <td class="d-flex justify-end align-center">
          <v-tooltip location="top" :open-delay="500">
            <template v-slot:activator="{ props }">
              <v-icon
                size="small"
                class="mr-1"
                @click="
                  () => {
                    dialogMode = 'Edit'
                    handleDialog = true
                    selectedHandle = item
                  }
                "
                v-bind="props"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Edit Handle</span>
          </v-tooltip>
          <v-tooltip v-if="$store.state.user.permissions.admin" location="top" :open-delay="500">
            <template v-slot:activator="{ props }">
              <v-icon
                size="small"
                @click="
                  () => {
                    deleteHandleDialog = true
                    selectedHandle = item
                  }
                "
                v-bind="props"
                >mdi-delete</v-icon
              >
            </template>
            <span>Delete Handle</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="handleDialog" width="800">
      <v-card>
        <v-card-title class="bg-primary text-white text-h6">
          {{ dialogMode == 'Create' ? 'Create New Handle' : 'Edit Handle' }}
        </v-card-title>
        <v-card-text class="mt-3">
          <v-form>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="Code"
                  :disabled="dialogMode === 'Edit'"
                  v-model="selectedHandle.value"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Name" v-model="selectedHandle.text"></v-text-field>
              </v-col>
            </v-row>
            <v-text-field label="Cost" v-model.number="selectedHandle.cost"></v-text-field>
            <v-select
              v-model="selectedHandle.orientations"
              :items="filterOrientationOptions(selectedHandle)"
              label="Orientations"
              multiple
              chips
            ></v-select>
            <v-checkbox
              v-model="selectedHandle.hasInsert"
              label="Has Insert"
              @update:model-value="onInsertChange"
            ></v-checkbox>
            <v-row v-if="selectedHandle.hasInsert">
              <v-col cols="12"> Insert Size </v-col>
              <v-col cols="6">
                <v-select v-model="selectedHandle.insertWidthUnit" :items="['mm', '%']" label="Width Unit"></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Width Value" v-model.number="selectedHandle.insertWidthValue"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select v-model="selectedHandle.insertHeightUnit" :items="['mm', '%']" label="Height Unit"></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Height Value" v-model.number="selectedHandle.insertHeightValue"></v-text-field>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12" v-if="selectedHandle.value && selectedHandle.value == 'j'">
                <v-text-field
                  label="US Linear Cost Per Foot"
                  prefix="$"
                  v-model.number="selectedHandle.insertLinearFtCost"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-if="selectedHandle.value && !['j', 'invisipull', 'invisipull-short'].includes(selectedHandle.value)"
                  label="US Handles Additional Linear Foot"
                  prefix="Ft."
                  v-model.number="selectedHandle.insertAddLinearFt"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="text"
            @click="
              () => {
                handleDialog = false
              }
            "
            >Cancel</v-btn
          >
          <v-btn
            color="accent"
            variant="flat"
            @click="dialogMode === 'Create' ? createNewHandle() : updateHandle()"
            :disabled="submitting"
            >{{ dialogMode === 'Create' ? 'Create' : 'Update' }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteHandleDialog" width="800">
      <v-card>
        <v-card-title class="bg-primary text-white text-h6">Delete Handle</v-card-title>
        <v-card-text class="mt-3">
          <p>Are you sure you want to delete {{ selectedHandle.text }}?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="deleteHandleDialog = false">Cancel</v-btn>
          <v-btn color="accent" variant="flat" @click="deleteHandle()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import productData from '@/js/productData.js'
import { db } from '@/js/db'
import { collection, deleteDoc, doc, setDoc, updateDoc } from 'firebase/firestore'

export default {
  name: 'HandleSettings',
  data() {
    return {
      productData: productData,
      tableSearch: '',
      handles: null,
      handleDialog: false,
      deleteHandleDialog: false,
      submitting: false,
      selectedHandle: {},
      newHandleForm: {},
      loading: true,
      dialogMode: null,
      orientations: [
        { text: 'Horizontal', value: 'h' },
        { text: 'Vertical', value: 'v' },
        { text: 'Centered', value: 'c' },
        { text: 'Vertically Centered', value: 'vc' },
        { text: 'Vertical Base Top', value: 'vbt' },
        { text: 'Vertical Wall Bottom', value: 'vwb' },
        { text: 'Centered Upside Down', value: 'updn' }
      ],
      headers: [
        {
          title: 'Name',
          sortable: false,
          key: 'text'
        },
        {
          title: 'Has Insert',
          sortable: false,
          key: 'hasInsert'
        },
        {
          title: 'Orientations',
          sortable: false,
          key: 'orientations'
        },
        {
          title: 'UK Price',
          sortable: false,
          key: 'costUK'
        },
        {
          title: 'US Price',
          sortable: false,
          key: 'costUS'
        },
        {
          title: 'Cut Mu Adjust',
          sortable: false,
          key: 'cutMu'
        },
        {
          title: 'Finish Mu Adjust',
          sortable: false,
          key: 'finishMu'
        },
        {
          title: 'Actions',
          sortable: false,
          align: 'end',
          key: 'actions'
        }
      ]
    }
  },
  async mounted() {
    this.$live('handles', collection(db, 'handles'))
    this.loading = false
  },
  methods: {
    async createNewHandle() {
      this.submitting = true

      const newDocRef = doc(collection(db, 'handles'))
      await setDoc(newDocRef, this.newHandleForm)
      this.submitting = false
      this.handleDialog = false

      if (!this.selectedHandle) this.selectedHandle = this.handles[0]
    },
    async updateHandle() {
      this.submitting = true
      await setDoc(doc(db, 'handles', this.selectedHandle.id), this.selectedHandle)

      this.submitting = false
      this.handleDialog = false
      this.$store.commit('openSnackbar', { snackbarText: 'Handle Updated' })
    },
    onInsertChange(value) {
      if (!value) {
        delete this.selectedHandle.insertWidthUnit
        delete this.selectedHandle.insertWidthValue
        delete this.selectedHandle.insertHeightUnit
        delete this.selectedHandle.insertHeightValue
      }
    },
    deleteHandle() {
      deleteDoc(doc(db, 'handles', this.selectedHandle.id))
        .then(() => {
          this.$store.commit('openSnackbar', {
            snackbarText: 'Handle Deleted 🙌'
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    changed(item, attribute) {
      // update in firebase
      updateDoc(doc(db, 'handles', item.id), {
        [attribute]: item[attribute]
      })
        .then(() => {
          this.$store.commit('openSnackbar', {
            snackbarText: 'Handle Updated 🙌'
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    filterOrientationOptions(handle) {
      if (['semiGrab', 'midSemiGrab', 'lrgSemiGrab', 'lrgHalfArc', 'halfArc'].includes(handle.value)) {
        return this.orientations
      } else {
        return this.orientations.filter((o) => o.value !== 'updn')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
